module.exports = __webpack_public_path__ + "img/hr-heat-pipe-straight-vertical-single.ba0201a7.png";